import { type ReactNode } from 'react';
import { cn } from './cn';

export interface PageHeaderProps {
  title: string;
  description?: ReactNode;
  /** Optional leading icon element. */
  icon?: ReactNode;
  /** Optional right-aligned actions (buttons, filters, etc.). */
  actions?: ReactNode;
  className?: string;
}

/** Consistent page title block used at the top of every feature page. */
export function PageHeader({
  title,
  description,
  icon,
  actions,
  className,
}: PageHeaderProps) {
  return (
    <div
      className={cn(
        'mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between',
        className,
      )}
    >
      <div className="flex items-start gap-3">
        {icon && (
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-surface-2 text-accent">
            {icon}
          </div>
        )}
        <div>
          <h1 className="text-xl font-semibold tracking-tight text-zinc-50">
            {title}
          </h1>
          {description && (
            <p className="mt-0.5 text-sm text-zinc-500">{description}</p>
          )}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
